import React from "react";
import AppleLogin from 'react-apple-login';

const AppleSignin = ({ handleSuccess: onSuccess, className }) => {
  const handleError = () => {
    alert("Login Failed");
  };

  return (
    <div
      className={className}
      style={{
        marginTop: "10px",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <AppleLogin
        clientId="com.gridient.web"
        redirectURI="https://enrollment-be.dev.gridient.io/v2/applecallback/token"
        usePopup={false}
        responseType={'code id_token'}
        responseMode={"form_post"}
        scope={"name email"}
        callback={onSuccess}
        onFailure={handleError}
        designProp={{
          height: 40,
          width: 240,
          color: "black",
          border: true,
          type: "sign-in",
          border_radius: 8,
          scale: 1,
          locale: "en_US"
        }}
      />
    </div>
  );
};

export default AppleSignin;
